export const PRIMARY_COLOR = '#793795'; // purple
export const SECONDARY_COLOR = '#ED1C24'; // red
export const SUB_TITLE_COLOR = '#4B5563';
export const WHITE_COLOR = '#ffffff';
export const GRAY_BG_COLOR = '#FAFAFA'; // gray
export const LIGHT_PURPLE = '#5B2C88'; // light purple
export const YELLOW = '#e6e600'; // yellow
